﻿module.exports = function ($, cookies) {
    return {
        init: function () {
           
            var headerOffset = (window.innerWidth < 767 ? 64 : (window.innerWidth < 1023 ? 118 : 178))

            $("a[href*='#']:not([href='#'])").click(function () {
                if (location.pathname.replace(/^\//, '') == this.pathname.replace(/^\//, '') && location.hostname == this.hostname) {
                    var target = $(this.hash);
                    target = target.length ? target : $('[id=' + this.hash.slice(1) + ']');
                    if (target.length) {
                        $('html,body').animate({
                            scrollTop: target.offset().top - headerOffset // minus fixed header height
                        }, 500);
                        return false;
                    }
                }
            });

            var offset = $(':target').offset();
            if (offset)
            {
                var scrollto = offset.top - headerOffset; // minus fixed header height
                $('html, body').animate({ scrollTop: scrollto }, 500);
            }

            var isSubmissions = $("body:first").hasClass("memberSubmissions");
            if (isSubmissions) {
                var referer = cookies.get('submission-referer');
                if (referer !== undefined && referer !== null && $("#Referer").val() === "") {
                    $("#Referer").val(referer);
                }
            }
            //} else {
            //    cookies.remove('submission-referer');
            //    var inFifteenMinutes = new Date(new Date().getTime() + 15 * 60 * 1000);
            //    cookies.set('submission-referer', window.location.href, { expires: inFifteenMinutes });
            //}
            $(".featuredContent__button a").on("click",
                function(e) {
                    cookies.remove('submission-referer');
                    var inFifteenMinutes = new Date(new Date().getTime() + 15 * 60 * 1000);
                    cookies.set('submission-referer', window.location.href, { expires: inFifteenMinutes });
                });


            let newMobileNav = $('#newMobileNav');
            newMobileNav.find('.nav__main__menu ul').hide();
            newMobileNav.find('a').click(function () {
                let ul = $(this).parent('li').children('ul');
                if (ul.length) {
                    if (ul.is(':visible'))
                        ul.hide();
                    else
                        ul.show();
                    return false;
                }
            });

        }
    };
};